import React from 'react';
import { FilterItemProps } from './FilterItemDisplay';
import { isDynamicYearFilter } from 'components/SentenceFilter/FilterManagees/YearFilter/helpers/definitions';
import { Typography } from '@mui/material';
import { useRenderOperationValue } from 'components/SentenceFilter/FilterManagees/YearFilter/hooks/valueRenderers';
import { FilterOperations } from 'business/definitions';

const YearFilterItem = ({ filter }: FilterItemProps) => {
    const isDynamicFilter = filter.value && isDynamicYearFilter(filter.value);

    const renderValue = useRenderOperationValue(
        filter,
        !!isDynamicFilter,
        true,
    );

    return (
        <Typography>
            {isDynamicFilter || filter.operation === FilterOperations.is_null
                ? renderValue(`${filter.operation}-${filter.value}`)
                : `${renderValue(filter.operation)} ${filter.value}`}
        </Typography>
    );
};

export default YearFilterItem;
